import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  changeCardsSuccessAction,
  setCardsToStoreAction,
  setHasUndefinedCardToStore,
  setNextCardPositionToStore,
} from 'data/reducers';
import { CardsChangedResponse, Notifications } from 'types';

export function* cardsChanged({ type: notificationType, data: result }: CardsChangedResponse) {
  try {
    if (notificationType === Notifications.CARDS_CHANGED) {
      const { cards } = result;
      yield put(changeCardsSuccessAction());
      yield put(setCardsToStoreAction(cards));
      yield put(setHasUndefinedCardToStore(false));
      yield put(setNextCardPositionToStore(null));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
